
import { Link } from 'react-router-dom';

export default function ChairLineupHero() {
  return (
    <section
      className="relative min-h-[85svh] flex items-center justify-center overflow-hidden"
      aria-label="MeVER Chair ヒーロー"
    >
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ae3360b92c9bbfa009a6ebd238ef6b14.jpg"
          alt="MeVER Chair プロフェッショナルワークスペース"
          className="w-full h-full object-cover object-top"
          loading="eager"
          width="1920"
          height="1080"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/80"></div>
      </div>

      <div className="relative z-10 text-center px-4 sm:px-6 max-w-5xl mx-auto w-full py-20 sm:py-32">
        <span className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6 sm:mb-8">
          <span className="w-1.5 h-1.5 bg-[#8E7AB5] rounded-full" aria-hidden="true"></span>
          <span className="text-xs sm:text-sm font-light text-white/80 tracking-[0.15em]">ERGONOMIC CHAIR SERIES</span>
        </span>

        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-extralight text-white mb-4 sm:mb-6 tracking-[0.08em] leading-tight">
          Sit. Focus. Flow.
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl font-extralight text-white/70 mb-4 sm:mb-6 tracking-[0.12em]">
          あなたの「集中」に寄り添う、3つのチェア
        </p>
        <p className="text-sm sm:text-base font-extralight text-white/50 max-w-2xl mx-auto mb-10 sm:mb-14 leading-relaxed tracking-wide">
          プロフェッショナルからライフスタイルまで。<br className="hidden sm:block" />
          MeVER Chairは、体型・用途・空間に合わせて選べる3モデルをラインナップ。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5">
          <a
            href="#lineup"
            className="w-full sm:w-auto px-8 sm:px-10 py-3.5 sm:py-4 bg-[#8E7AB5] text-white text-sm sm:text-base font-light tracking-[0.1em] hover:bg-[#7A6A9E] transition-all whitespace-nowrap rounded-md cursor-pointer text-center"
          >
            ラインナップを見る
          </a>
          <a
            href="https://appointment.mever.design/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center px-8 sm:px-10 py-3.5 sm:py-4 bg-white text-black text-sm sm:text-base font-light tracking-[0.1em] hover:bg-white/90 transition-all whitespace-nowrap rounded-md cursor-pointer"
          >
            <i className="ri-calendar-check-line mr-2" aria-hidden="true"></i>
            体験予約
          </a>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/40 text-xl" aria-hidden="true"></i>
      </div>
    </section>
  );
}
